import React from 'react'
import { Outlet, useLocation } from 'react-router-dom';
import { Header } from "../Header/Header";
import Footer from "../Footer/Footer";
import GlobalFaq from "../faq/GlobalFaq";


const Layout = ({ initialFaq }) => {
  const location = useLocation();
  const isBlogDetail = /^\/blog\/[^/]+\/?$/.test(location.pathname);

  return (
    <>
      <Header />
      <main>
        <Outlet />
      </main>
      {!isBlogDetail && <GlobalFaq initialFaq={initialFaq} />}
      <Footer />
    </>
  );
};

export default Layout;
